import {InfiniteData} from '@tanstack/react-query';
import flatten from 'lodash/flatten';

/**
 * react-query infinite data 형태를 list와 나머지 데이터로 분리하여 리턴합니다.
 */
export function selectListAndRestData<
  Query extends {[index: string]: any},
  OperationKey extends string,
>(
  operationKey: OperationKey,
  infiniteData?: InfiniteData<Query>
): Query[OperationKey] | undefined {
  if (!infiniteData) {
    return undefined;
  }
  const list = flatten(infiniteData.pages.map(item => item[operationKey].list));
  return {
    ...infiniteData.pages[infiniteData.pages.length - 1][operationKey],
    list,
  };
}
